import { BenefitsListFragmentFragment } from '../../../__generated__/graphql';
import ListItemHeading from '../../../components/ListItemHeading';
import { Paragraph } from '../../../components/Text';

import style from './benefit-list-item.module.css';

type BenefitsList = NonNullable<BenefitsListFragmentFragment['benefitsList']>;
type Benefits = NonNullable<NonNullable<BenefitsList['benefits']>>;
type Benefit = NonNullable<Benefits[number]>;

interface BenefitListItemProps {
  benefit: Benefit;
}

const BenefitListItem = ({ benefit: benefitsListItem }: BenefitListItemProps) => (
  <li className={style.benefitListItem}>
    {benefitsListItem.title && (
      <ListItemHeading className={style.benefitListItemHeading}>
        {benefitsListItem.title}
      </ListItemHeading>
    )}

    {benefitsListItem.description && (
      <Paragraph
        fontColor="white"
        fontSize={15}
      >
        {benefitsListItem.description}
      </Paragraph>
    )}
  </li>
);

export default BenefitListItem;
